import React from "react";
import { object, string } from "prop-types";

import SavedStoryView from "../../rows/SavedStoryView";

const SavedPage = ({ currentPath }) => {
  return <SavedStoryView currentPath={currentPath} />;
};

SavedPage.propTypes = {
  member: object,
  currentPath: string
};

export { SavedPage };
